import type { WidgetSchema } from '../types';

// The heatmap's data source (/api/widgets/heatmap) currently returns mock data,
// so it ships as coming-soon until it is backed by real market stats.
export const marketHeatmap: WidgetSchema = {
    meta: {
        id: 'market-heatmap',
        category: 'heatmaps',
        categoryTitle: 'Heatmaps',
        title: 'Market Heatmap',
        description: 'A heatmap of market activity across a category.',
        status: 'coming-soon',
        hideFromSidebar: true,
    },
    fields: [],
    preview: { kind: 'event-loader' },
    embed: { kind: 'event-loader', fixed: {} },
};
